module.exports = __webpack_public_path__ + "assets/img/ffj-qj.2388df2c.png";